import { DEFAULT_PLATFORM_NAME, DEFAULT_PLATFORM_TYPE } from "./constants";
import { getCookie } from "./cookie";
import type {
  CollectCallback,
  CollectConfig,
  PublicProperty,
  PublicPropertyValue,
} from "./types";

export function createDefaultPublicProperties(
  opts: CollectConfig,
): Record<string, PublicProperty> {
  return {
    platform_type: resolvePublicProperty(
      opts.platform_type,
      DEFAULT_PLATFORM_TYPE,
    ),
    platform_name: resolvePublicProperty(
      opts.platform_name,
      DEFAULT_PLATFORM_NAME,
    ),
    is_login: () =>
      resolvePublicProperty(opts.is_login, Boolean(getCookie("x-u-mi"))),
    current_account_type: () =>
      resolvePublicProperty(opts.current_account_type, getDefaultAccountType()),
  };
}

export function createDefaultProfileProperties(): Record<string, string> {
  const properties: Record<string, string> = {};
  const memberId = getCookie("x-u-mi");
  const deviceId = getCookie("x-device-id");

  if (memberId) {
    properties.member_id = memberId;
  }

  if (deviceId) {
    properties.device_id = deviceId;
  }

  return properties;
}

export function mergeCommonProperties(
  title: string,
  params?: Record<string, any> | CollectCallback,
): Record<string, any> {
  const properties: Record<string, any> = {};

  if (typeof params === "object" && params) {
    Object.keys(params).forEach((key) => {
      properties[key] = params[key];
    });
  }

  if (!Object.prototype.hasOwnProperty.call(properties, "$url")) {
    properties.$url = getCurrentUrl();
  }

  if (!Object.prototype.hasOwnProperty.call(properties, "$title")) {
    properties.$title = title || getCurrentTitle();
  }

  return properties;
}

export function resolvePublicProperty(
  value: PublicProperty | undefined,
  fallback: PublicPropertyValue,
): PublicPropertyValue {
  if (typeof value === "function") {
    try {
      return value();
    } catch (error) {
      logPropertiesError("public property getter", error);
      return fallback;
    }
  }

  if (typeof value !== "undefined" && value !== null) {
    return value;
  }

  return fallback;
}

export function getDefaultAccountType(): string {
  if (!getCookie("x-u-mi")) return "";
  const accountType = getCookie("x-u-gt");
  // x-u-gt 1：常规账户 2：体验账户（游客账户） 4-亲情号
  if (accountType === "2") {
    return "游客账户";
  }
  return "登录账户";
}

function getCurrentUrl(): string {
  try {
    return window.location.href;
  } catch (error) {
    logPropertiesError("read current url", error);
    return "";
  }
}

function getCurrentTitle(): string {
  try {
    return document.title;
  } catch (error) {
    logPropertiesError("read document title", error);
    return "";
  }
}

function logPropertiesError(context: string, error: unknown): void {
  if (typeof console !== "undefined" && console.error) {
    console.error(`[GatCollect] ${context} error:`, error);
  }
}
